import React from 'react';
import { Flex, Typography, Col, theme } from 'antd';
import { GlassCard } from '../../../../shared/components';
import { MessageOutlined, MessageTwoTone } from '@ant-design/icons';
import { useTranslate } from '@refinedev/core';

const { Title } = Typography;

interface OrderCommentsProps {
    comments?: string;
}

const CardTitle = ({ title, bg = 'bg-white' }: { title: string; bg?: string }) => {
    const { token } = theme.useToken();
    return (
        <Flex justify="left" align="center" className="mb-4">
            <div className={`text-center px-4 text-base font-semibold`} style={{ color: token.colorText }}>
                {title}
            </div>
        </Flex>
    );
};

export const OrderComments: React.FC<OrderCommentsProps> = ({ comments }) => {
    const _t = useTranslate();
    const { token } = theme.useToken();

    if (!comments) {
        return null;
    }

    return (

        <GlassCard className="shadow-lg min-h-[138px]">
            <CardTitle title={_t("orders.fields.comments")} />
            <div className="flex items-start  space-x-3 p-2 rounded-lg border mt-2" style={{ borderColor: token.colorPrimary }}>
                <div className="flex-shrink-0">
                    <MessageOutlined style={{ color: token.colorPrimary }} />
                </div>
                <div className="flex-1 min-w-0">
                    <div style={{ color: token.colorText }}>
                        {comments}
                    </div>
                </div>
            </div>
        </GlassCard>

    );
}; 